/*
 * @Author: 毛和水
 * @Date: 2024-04-24 21:11:12
 * @LastEditors: 毛和水
 * @LastEditTime: 2024-05-15 20:37:56
 * @Description: file content
 */
import type {
  IStatisticsOfChangeModel,
  IStatisticsOfChangeStore,
} from '@monorepo/types/document/statisticsOfChange/statisticsOfChange.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IStatisticsOfChangeStore = {
  isInit: true,
  tableList: [],
  categoryTableList: [],
  locationTableList: [],
  summary: {},
  total: 0,
  categoryTableTotal: 0,
  locationTableTotal: 0,
  query: {
    location_id_list: [],
    productPageSize: 50,
    productPage: 1,
    locationPageSize: 50,
    locationPage: 1,
    categoryPageSize: 50,
    categoryPage: 1,
    date: getToday(),
    unit: 'BASE_UNIT',
    query_bigin_end_inventory: true,
  },
};

const statisticsOfChangeModel: IStatisticsOfChangeModel = {
  namespace: 'statisticsOfChange',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default statisticsOfChangeModel;
